require('./dist/carousel/carousel.css');
